import { cdnImages } from "@/lib/cdn-images";

export type FeatureCard = {
  eyebrow: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  imageWidth: number;
  imageHeight: number;
};

export const featureCards: FeatureCard[] = [
  {
    eyebrow: "Lectures",
    title: "Concept lectures",
    description: "Chapter-wise, at your own pace.",
    image: cdnImages.conceptLecture,
    imageAlt: "Concept lecture on Pi",
    imageWidth: 654,
    imageHeight: 1260,
  },
  {
    eyebrow: "Practice",
    title: "Tests & DPPs",
    description: "Daily problems, tests and mocks.",
    image: cdnImages.testArena,
    imageAlt: "Test Arena on Pi",
    imageWidth: 660,
    imageHeight: 1262,
  },
  {
    eyebrow: "Educators",
    title: "All your teachers",
    description: "PW's most-loved faculty, in one place.",
    image: cdnImages.teachers,
    imageAlt: "Teachers on Pi",
    imageWidth: 662,
    imageHeight: 1266,
  },
  {
    eyebrow: "AI doubts",
    title: "Ask AI",
    description: "Instant answers, right in the lecture.",
    image: cdnImages.askAi,
    imageAlt: "Ask AI on Pi",
    imageWidth: 662,
    imageHeight: 1264,
  },
];
